import { css } from "@emotion/css";
import type { TagSetResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { MissingChip } from "~/components/Chips";
import Tag from "~/components/Tag/index";
import type { RunbooksFilterState } from "../hooks/useRunbooksFilterState";
interface FilteredByChipsProps {
    filterState: RunbooksFilterState;
    tagSets: TagSetResource[];
}
export function FilteredByChips({ filterState, tagSets }: FilteredByChipsProps) {
    const { filterByTags } = filterState;
    if (filterByTags.length === 0) {
        return null;
    }
    return (<div className={styles.container}>
            <span>
                {filterByTags.map((tagId, index) => {
            const tagWithSet = tagSets.flatMap((ts) => ts.Tags.map((tag) => ({ tag, set: ts }))).find((item) => item.tag.Id === tagId);
            const tag = tagWithSet?.tag;
            return (<React.Fragment key={tagId}>
                            {index > 0 && <Or />}
                            {tag ? <Tag tagName={tag.Name} description={tag.Description} tagColor={tag.Color} small={false}/> : <MissingChip lookupId={tagId}/>}
                        </React.Fragment>);
        })}
            </span>
        </div>);
}
function Or() {
    return <span className={styles.delimiter}>or</span>;
}
const styles = {
    container: css({
        display: "flex",
        alignItems: "center",
    }),
    delimiter: css({
        fontSize: "0.9rem",
    }),
};
